/**
 * Whether a page-level filter should be shown, given the page's org meta block.
 *
 * Battery Intelligence reads the same shape for SOHAndRUL, but with the opposite
 * default: it was built around the block, so an absent key there means hidden.
 * The BMS Faults filters predate any such block and have always been on the page,
 * so an absent key must mean shown - otherwise every org without the new
 * configuration loses its filters the moment this ships.
 *
 * Only a boolean `false` hides. A null, an empty string, or the string "false"
 * from a hand-edited JSON row is a configuration mistake, and the safe reading of
 * a mistake is to leave a filter people rely on in place rather than remove it.
 * Someone who meant to hide one will see it still there and correct the row; the
 * opposite failure is silent.
 */
export const isFilterVisible = (pageFiltersConfig, key) =>
  (pageFiltersConfig || {})[key] !== false;
